import { ReactElement, useEffect, useMemo, useState } from 'react';
import { timeoutDuration } from 'utils/constants/dateInfo/time-numbers';
import { ConditionalWrapper } from 'components/ConditionalWrapper';

type TSportsbookWidgetsHeightWrapperProps = {
  shouldWrap: boolean;
  childrenElementId: string;
} & PropsWithChildren;

const _SportsbookWidgetsHeightWrapper = ({
  children,
  childrenElementId
}: Omit<TSportsbookWidgetsHeightWrapperProps, 'shouldWrap'>): ReactElement => {
  const [offsetTopValue, setOffsetTopValue] = useState(0);

  const wrapperStyles = useMemo(
    () => ({
      width: '100%',
      height: `calc(100vh - ${offsetTopValue}px)`,
      overflow: 'auto'
    }),
    [offsetTopValue]
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      const element = document.getElementById(childrenElementId);

      if (element) {
        const elemTopValue =
          element.getBoundingClientRect().top +
            document.documentElement.scrollTop || 0;

        setOffsetTopValue(elemTopValue);
      }
    }, timeoutDuration.DURATION_500);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div style={wrapperStyles} id={childrenElementId}>
      {children}
    </div>
  );
};

export const SportsbookWidgetsHeightWrapper = ({
  children,
  childrenElementId,
  shouldWrap
}: TSportsbookWidgetsHeightWrapperProps): ReactElement => {
  return (
    <ConditionalWrapper
      condition={shouldWrap}
      wrapper={children => (
        <_SportsbookWidgetsHeightWrapper childrenElementId={childrenElementId}>
          {children}
        </_SportsbookWidgetsHeightWrapper>
      )}
    >
      {children}
    </ConditionalWrapper>
  );
};
